/**
 * Cart Fix - Maximum Compatibility Mode
 *
 * This file fixes the add-to-cart functionality by ensuring all cart handlers
 * use the URL-encoded format that works with both preview environments and
 * production Shopify stores.
 *
 * Date: 2026-01-20
 * Issue: Multiple cart handlers using conflicting data formats
 */

(function() {
  'use strict';

  console.log('[Cart Fix] 🔧 Loading compatibility fix...');

  // Override the window.AjaxCart prototype if it exists
  if (typeof window.AjaxCart !== 'undefined') {
    console.log('[Cart Fix] 🔄 Overriding AjaxCart.addItemFromForm...');

    var originalEventListeners = window.AjaxCart.prototype.eventListeners;

    window.AjaxCart.prototype.eventListeners = function() {
      if (this.$form.length) {
        // Remove any existing submit handlers
        this.$form.off('submit');

        // Add our fixed handler
        this.$form.on('submit', $.proxy(function(evt) {
          console.log('[Cart Fix] 🎯 Form submitted via AjaxCart');
          evt.preventDefault();
          evt.stopImmediatePropagation();

          var $form = this.$form;
          var $submitButton = $form.find('button[type="submit"]');
          $submitButton.addClass('is-loading');

          var formData = new FormData($form[0]);
          var variantId = formData.get('id');
          var quantity = formData.get('quantity') || 1;

          // Use modern Shopify Cart API format with items array
          var requestData = {
            items: [{
              id: parseInt(variantId, 10),
              quantity: parseInt(quantity, 10)
            }]
          };

          console.log('[Cart Fix] 📤 Sending data:', JSON.stringify(requestData));

          var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify(requestData),
            contentType: 'application/json',
            dataType: 'json',
            success: $.proxy(function(response) {
              console.log('[Cart Fix] ✅ Success:', response);
              this.success(response);
            }, this),
            error: $.proxy(function(XMLHttpRequest, textStatus) {
              console.error('[Cart Fix] ❌ Error:', XMLHttpRequest.responseText);
              this.error(XMLHttpRequest, textStatus);
            }, this),
            complete: function() {
              $submitButton.removeClass('is-loading');
            }
          };

          $.ajax(params);
        }, this));
      }
    };
  }

  // Wait for DOM ready to reinitialize AjaxCart instances
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reinitializeAjaxCart);
  } else {
    reinitializeAjaxCart();
  }

  function reinitializeAjaxCart() {
    console.log('[Cart Fix] 🔄 Reinitializing AjaxCart instances...');

    // Find all product forms
    var $forms = $('form[action*="/cart/add"]');
    console.log('[Cart Fix] Found ' + $forms.length + ' product form(s)');

    // Reinitialize each form with our fixed AjaxCart
    $forms.each(function() {
      var $form = $(this);

      // Skip if already handled by the product template fix
      if ($form.data('cart-fix-applied')) {
        console.log('[Cart Fix] ⏭️ Skipping form (already fixed):', $form.attr('id'));
        return;
      }

      // Remove existing handlers
      $form.off('submit');

      // Create new AjaxCart instance if the class exists
      if (typeof window.AjaxCart !== 'undefined') {
        console.log('[Cart Fix] ✅ Applying fix to form:', $form.attr('id'));
        new window.AjaxCart($form);
        $form.data('cart-fix-applied', true);
      }
    });
  }

  console.log('[Cart Fix] ✅ Compatibility fix loaded successfully!');
})();
